import { create } from 'zustand';

import { IQuestionAnswer, IQuestion } from '@src/types';

interface IQuestionStore {
  questions: IQuestion[];
  myQuestionsList: string[];
  setQuestions: (questions: IQuestion[]) => void;
  addQuestion: (question: IQuestion) => void;
  updateQuestion: (questionId: string, question: Partial<IQuestion>) => void;
  removeQuestion: (id: string) => void;
  clearQuestions: () => void;
  answerQuestion: (questionId: string, answer: IQuestionAnswer) => void;
  isQuestionBoxOpened: boolean;
  questionToEdit: IQuestion | null;
  setIsQuestionBoxOpened: (opened: boolean) => void;
  setQuestionToEdit: (question: IQuestion | null) => void;
  isAnswerBoxOpened: boolean;
  answerToEdit: IQuestionAnswer | null;
  setIsAnswerBoxOpened: (opened: boolean) => void;
  setAnswerToEdit: (answer: IQuestionAnswer | null) => void;
}

export const useQuestionAndAnswerStore = create<IQuestionStore>((set, get) => ({
  questions: [],
  myQuestionsList: [],
  setQuestions: (questions: IQuestion[]) => set({ questions }),
  addQuestion: (question: IQuestion) =>
    set((state) => {
      const updatedQuestions = [...(state.questions || [])];
      const questionIndex = state.questions.findIndex(({ id = '' }) => id === question.id);
      if (questionIndex > -1) {
        updatedQuestions[questionIndex] = { ...updatedQuestions[questionIndex], ...question };
        return { ...state, questions: updatedQuestions };
      }
      return {
        ...state,
        questions: [...state.questions, question],
      };
    }),
  updateQuestion: (questionId, question) =>
    set((state) => ({
      questions: state.questions.map((q) => (q.id === questionId ? { ...q, ...question } : q)),
    })),
  removeQuestion: (id: string) =>
    set((state) => ({
      questions: state.questions.filter((q) => q.id !== id),
    })),
  clearQuestions: () => set({ questions: [] }),
  answerQuestion: (questionId: string, answer: IQuestionAnswer) =>
    set((state) => ({
      questions: state.questions.map((q) => (q.id === questionId ? { ...q, answer } : q)),
    })),

  isQuestionBoxOpened: false,
  questionToEdit: null,
  setIsQuestionBoxOpened: (opened: boolean) => set({ isQuestionBoxOpened: opened }),
  setQuestionToEdit: (question: IQuestion | null) => set({ questionToEdit: question }),
  isAnswerBoxOpened: false,
  answerToEdit: null,
  setIsAnswerBoxOpened: (opened: boolean) => set({ isAnswerBoxOpened: opened }),
  setAnswerToEdit: (answer: IQuestionAnswer | null) => set({ answerToEdit: answer }),
}));
